import { Link } from 'react-router';

import quickQuotLogo from '../../assets/images/laEstimator_powered.svg';
import warning from '../../assets/images/warning.svg';
import './page-wrapper.scss';
import { routes } from '../../const/routes';

const PageWrapper = ({ children }) => {
  return (
    <>
      <aside className="laForm__aside">
        <div className="laForm__aside-links">
          <img
            src={quickQuotLogo}
            alt="QuickQuote"
            width="226"
            height="28"
            loading="lazy"
          />
          <Link to={routes.landingPage} title="Home" />
          <a
            href="https://lasoft.org/"
            title="Lasoft Innovation Lab"
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
        <div className="laForm__aside-note">
          <div>
            <img
              src={warning}
              alt="warning"
              width="16"
              height="16"
              loading="lazy"
            />
            <strong>Please note:</strong>
          </div>
          <p>
            This calculator is intended for projects with a budget of{' '}
            <strong>$20,000</strong> or more.
          </p>
        </div>
      </aside>
      {children}
    </>
  );
};

export default PageWrapper;
